import * as React from "react";
import PropTypes from "prop-types";
const SvgSportsSnowNormalMedium = React.forwardRef(
  ({ color = "currentColor", size = 32, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M17.25 0v4.167l3.333-2.5 1.5 2-4.833 3.625v6.543l5.667-3.272.723-5.998 2.482.3L25.624 9l3.608-2.084 1.25 2.166-3.609 2.083 3.832 1.637-.982 2.299-5.556-2.374L18.5 16l5.666 3.271 5.556-2.373.982 2.3-3.832 1.636 3.608 2.083-1.25 2.165L25.623 23l.498 4.137-2.482.299-.722-5.999-5.667-3.271v6.543l4.833 3.625-1.5 2-3.333-2.5V32h-2.5v-4.167l-3.333 2.5-1.5-2 4.833-3.625v-6.542l-5.666 3.27-.723 6-2.482-.3L6.377 23 2.77 25.083l-1.25-2.165 3.608-2.084-3.831-1.636.982-2.3 5.556 2.374L13.5 16l-5.668-3.272-5.556 2.373-.982-2.299 3.832-1.636-3.609-2.084 1.25-2.165L6.377 9l-.498-4.136 2.482-.3.722 5.999 5.667 3.272V7.292L9.917 3.667l1.5-2 3.333 2.5V0z"
        fill=""
      />
    </svg>
  )
);
SvgSportsSnowNormalMedium.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgSportsSnowNormalMedium;
